// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.ps[data-v-18ba6fa2] {\n    height: var(--ps-height);\n}\n", ""]);
// Exports
module.exports = exports;
